export function getDropReportToDate(drop, lastReviewedDareDate) {
    const { expirationDate } = drop;
    if (!expirationDate) {
        return new Date().toISOString();
    }
    const isExpired = new Date(expirationDate) < new Date();
    if (!isExpired) {
        return new Date().toISOString();
    }
    if (lastReviewedDareDate && new Date(lastReviewedDareDate) > new Date(expirationDate)) {
        return lastReviewedDareDate;
    }
    return expirationDate;
}
